import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {Link, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getClients, getTopClients} from "../../store/reducers/ClientsSlice";
import Pagination from "../common/Pagination";
import EmailsSearch from "./components/EmailsSearch";
import {getOrders} from "../../store/reducers/OrdersSlice";
import ElogTextarea from "../common/form/ElogTextarea";
import {EmailsTable} from "./components/EmailsTable";
import {getEmails} from "../../store/reducers/EmailsSlice";

interface EmailsScreenProps {
}

export const EmailsScreen: React.FC<EmailsScreenProps> = () => {

    const dispatch = useAppDispatch();
    const routeParams = useParams();

    const emailsState = useAppSelector((state) => state.emails);

    const perPage = parseInt(new URLSearchParams(window.location.search).get('perPage') || '30', 10);

    return (
        <LoggedInView fullWidth={false}>
            <EmailsSearch />
            <EmailsTable />
            <Pagination totalItems={emailsState.total} itemsPerPage={perPage}  />
        </LoggedInView>
    )
}

